import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import commonService from './commonService';

const initialState = {
    countyList: [],
    isError: false,
    isSuccess: false,
    isLoading: false,
    message: ''
};

export const getAllCounty = createAsyncThunk(
    'common/getallcounty', async (_, thunkAPI) => {
        try {
            return await commonService.getAllCounty()
        } catch (error) {
            const message =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(message)
        }
    }
)

export const commonSlice = createSlice({
    name: 'common',
    initialState,
    reducers: {
        reset: (state) => {
            state.countyList = [];
            state.isLoading = false;
            state.isError = false;
            state.isSuccess = false;
            state.message = ''
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllCounty.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getAllCounty.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.countyList = action.payload.counties
                console.log(action.payload.counties)
            })
            .addCase(getAllCounty.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
    }

});

export const { reset } = commonSlice.actions;

export default commonSlice.reducer;